/**
 *
 * FormSymptomCodesPicker
 *
 */
import { Entity } from 'types/common';
import { FieldHookConfig, useField } from 'formik';
import { IFieldProps } from './FormRender/IFormFieldSetting';
import {
  ISymptomCodesParamsPicker,
  SymptomCodesPicker,
} from '../pickers/AutocompletePickers/SymptomCodesPicker';

export const FormSymptomCodesPicker = ({
  label,
  ...props
}: FieldHookConfig<Entity<number> | null> &
  IFieldProps &
  ISymptomCodesParamsPicker) => {
  const [field, meta, helpers] = useField<Entity<number> | null>(props);
  return (
    <>
      <SymptomCodesPicker
        AssetCats={props.AssetCats}
        name={props.name}
        placeholder={props.placeholder}
        label={label}
        variant="filled"
        onChange={value => {
          helpers.setValue(value, true);
          if (props.onChange) {
            props.onChange(value);
          }
        }}
        info={props.info}
        onBlur={field?.onBlur}
        value={field.value}
        error={meta?.error !== undefined}
        helperText={meta.error}
        fullWidth={props.fullWidth}
        disabled={props.disabled}
      />
    </>
  );
};
